import { useState } from "react";

import { Menu, MenuItem, Stack } from "@mui/material";

import { ReactComponent as BlueDot } from "../../../Assets/Images/Icon/Grid/BlueDotICON.svg";

export const ActionButton = ({ Options, clickHandler }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  return (
    <>
      <Stack
        style={{
          width: "5px",
          cursor: "pointer",
          position: "relative",
          left: "50%",
        }}
        gap={"2px"}
        onClick={handleClick}
      >
        <BlueDot
          role="img"
          type="img"
          aria-label="BlueDot Icon"
          style={{ width: "4px", height: "4px" }}
        />
        <BlueDot
          role="img"
          type="img"
          aria-label="BlueDot Icon"
          style={{ width: "4px", height: "4px" }}
        />
        <BlueDot
          role="img"
          type="img"
          aria-label="BlueDot Icon"
          style={{ width: "4px", height: "4px" }}
        />
      </Stack>
      <Menu
        onClose={() => setAnchorEl(null)}
        closeAfterTransition={true}
        open={anchorEl != null}
        anchorEl={anchorEl}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: "10px",
              padding: "1px 2px",
              alignContent: "flex-start",
              alignSelf: "stretch",
            },
          },
        }}
      >
        {anchorEl &&
          Options.map((item, index) => {
            const isShow = item.isShow;
            if (isShow !== undefined) {
              if (isShow) {
                return (
                  <MenuItem
                    key={index}
                    onClick={() => {
                      {
                        clickHandler && clickHandler(item.id);
                        setAnchorEl(null);
                      }
                    }}
                  >
                    {item.element}
                  </MenuItem>
                );
              } else return undefined;
            } else {
              return (
                <MenuItem
                  key={index}
                  onClick={() => {
                    {
                      clickHandler && clickHandler(item.id);
                      setAnchorEl(null);
                    }
                  }}
                >
                  {item.element}
                </MenuItem>
              );
            }
          })}
      </Menu>
    </>
  );
};
